/**
 * @description function that breaks the current active countdown into
 * displayable days.
 * @param {number} countdown
 * @returns {object} days
 */
export const getCalculatedDays = (countdown) => {
    const days = Math.floor(countdown / (1000 * 60 * 60 * 24));
    return days >= 0 ? days : 0;
};

/**
 * @description function that breaks the current active countdown into
 * displayable hours.
 * @param {number} countdown
 * @returns {object} hours
 */
export const getCalculatedHours = (countdown) => {
    const hours = Math.floor(
        (countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    return hours >= 0 ? hours : 0;
};

/**
 * @description function that breaks the current active countdown into
 * displayable minutes.
 * @param {number} countdown
 * @returns {object} minutes
 */
export const getCalculatedMinutes = (countdown) => {
    const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
    return minutes >= 0 ? minutes : 0;
};

/**
 * @description function that breaks the current active countdown into
 * displayable seconds.
 * @param {number} countdown
 * @returns {object} seconds
 */
export const getCalculatedSeconds = (countdown) => {
    const seconds = Math.floor((countdown % (1000 * 60)) / 1000);
    return seconds >= 0 ? seconds : 0;
};

/**
 * @description function that breaks the current active countdown into
 * displayable increments of time.
 * @param {number} countdown
 * @returns {object} days, hours, minutes and seconds
 */
export const getFormattedCountdown = (countdown) => {
    const days = getCalculatedDays(countdown);

    const hours = getCalculatedHours(countdown);

    const minutes = getCalculatedMinutes(countdown);

    const seconds = getCalculatedSeconds(countdown);

    return { days, hours, minutes, seconds };
};
